import {
  EDITOR_PAGE_LOADED,
  EDITOR_PAGE_UNLOADED,
  ARTICLE_SUBMITTED,
  ASYNC_START,
  ADD_TAG,
  REMOVE_TAG,
  UPDATE_FIELD_EDITOR,
  ANSWER_SUBMITTED
} from '../constants/actionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case EDITOR_PAGE_LOADED:
      return {
        ...action.payload,
        body: '',
        answer: '',
        ...state,
      };
    case EDITOR_PAGE_UNLOADED:
      return {};
    case ANSWER_SUBMITTED:
      // this state seems to be shared between all instances of the component?
      return {
        ...state,
        answer: action.payload.content
      };
    case ARTICLE_SUBMITTED:
      return {
        ...state,
        inProgress: null,
        errors: action.error ? action.payload.errors : null
      };
    case ASYNC_START:
      if (action.subtype === ARTICLE_SUBMITTED) {
        return { ...state, inProgress: true };
      }
      break;
    case UPDATE_FIELD_EDITOR:
      return { ...state, [action.key]: action.value };
    default:
      return state;
  }

  return state;
};



// WEBPACK FOOTER //
// ./src/reducers/editor.js